import React, {memo} from 'react';
import {DrawerContent} from '@redlink/components/organisms';
import {useTheme} from '@redlink/assets/styles';

export const DashboardDrawer = memo(({Drawer, children}) => {
    const {colors, size, shadow, theme} = useTheme();
    return (
        <Drawer.Navigator
            screenOptions={{
                drawerType: 'permanent',
                drawerPosition: 'left',
                drawerStyle: {
                    width: size.drawerWidth,
                    marginTop: __ADMIN__ ? 0 : -60,
                    backgroundColor: colors.white,
                    ...(theme === 'dark' && {borderRightColor: colors.transparent})
                },
                headerShown: false,
                sceneContainerStyle: {
                    backgroundColor: colors.blue2,
                },
                drawerItemStyle: {
                    borderWidth: 0
                },
                drawerActiveTintColor: colors.red1,
                drawerInactiveTintColor: colors.gray23,
                drawerLabelStyle: {
                    fontSize: size.textSize1,
                    marginTop: size.marginVertical1,
                },
                drawerContentStyle: {
                    ...shadow.drawer
                }
            }}
            drawerContent={(props) => <DrawerContent {...props} />}
        >
            {children}
        </Drawer.Navigator>
    );
});
